import { driver_clinic_calls } from "../../../networking/urlEndPoints";
import Axios from "../../../networking/interceptor";

export const startDriverClinicCall = async ({
	pharmacyId,
	appointmentId,
	pharmacyPatientId,
	manualToPhone,
}) => {
	const payload = {
		pharmacy_id: pharmacyId,
		appointment_id: appointmentId,
	};

	if (pharmacyPatientId != null) {
		payload.pharmacy_patient_id = pharmacyPatientId;
	}

	if (manualToPhone) {
		payload.manual_to_phone = manualToPhone;
	}

	const { data } = await Axios.post(driver_clinic_calls, payload);
	return data?.data ?? data;
};

export const fetchDriverClinicCallStatus = async (callRef) => {
	const { data } = await Axios.get(`${driver_clinic_calls}/${encodeURIComponent(callRef)}`);
	return data?.data ?? data;
};
